import { InputField } from '.';

export interface Address {
    address1: InputField<string>;
    address2: InputField<string>;
    city: InputField<string>;
    state:  InputField<string>;
    countryCode:  InputField<string>;
    zipCode:  InputField<string>;
}